import { ReactNode, FC } from 'react';
import { Text, Flex } from '@dodilio/ui-design-lib';
import { HeroShell } from '../../components/HeroShell';

interface VerifyAccountLayoutProps {
    children: ReactNode;
}

const VerifyAccountPane = () => (
    <>

        <h1
            style={{
                fontSize: 'clamp(22px, 2.6vw, 28px)',
                fontWeight: 500,
                lineHeight: 1.06,
                letterSpacing: '-0.03em',
                margin: '0 0 18px',
                color: 'var(--gray-12)',
            }}
        >
            Confirm{' '}
            <span
                style={{
                    color: 'var(--gray-11)',
                    fontWeight: 300,
                    fontSize: '0.78em',
                }}
            >
                it&apos;s you.
            </span>
        </h1>

        <Text
            as="p"
            size="2"
            className="heroPaneDesc"
            style={{ color: 'var(--gray-11)', margin: '0 0 20px', lineHeight: 1.5 }}
        >
            We sent a 6-digit code to your email.
        </Text>

        <Flex direction="column" align="center" gap="2" className="heroPaneDesc">
            <Text size="2" style={{ color: 'var(--gray-10)' }}>
                Didn&apos;t get the email? Check your spam folder, or hit resend.
            </Text>
            <Text size="2" style={{ color: 'var(--gray-10)' }}>
                The code expires in 5 minutes.
            </Text>
        </Flex>
    </>
);

export const VerifyAccountLayout: FC<VerifyAccountLayoutProps> = ({ children }) => {
    return (
        <HeroShell title="Verify your email" leftPane={<VerifyAccountPane />}>
            {children}
        </HeroShell>
    );
};
